import { ref } from 'vue';
import { type Draft, editDraft, queryDraft } from './services';

export const useDraft = (viewName: string) => {
  const loading = ref(false);

  const saveDraft = async (params: Draft, isPlatform = false) => {
    try {
      loading.value = true;
      const res = await editDraft({ ...params, viewName }, isPlatform);
      return res;
    } catch (error) {
      throw error;
    } finally {
      loading.value = false;
    }
  };

  const getDrafts = async (isPlatform = false) => {
    try {
      loading.value = true;
      const drafts = await queryDraft(viewName, isPlatform);
      return drafts;
    } catch (error) {
      throw error;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    saveDraft,
    getDrafts
  };
};
